import { Button as MantineButton, type ButtonProps as MantineButtonProps } from '@mantine/core';
import React from 'react';

export interface ButtonProps extends MantineButtonProps {
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => Promise<void> | void;
    ref?: React.Ref<HTMLButtonElement>;
    disabled?: boolean;
    loading?: boolean;
    leftSection?: React.ReactNode;
    children?: React.ReactNode;
    type?: 'button' | 'submit' | 'reset';
}

export const Button = ({
    children,
    variant = 'outline',
    size = 'xs',
    c = 'var(--mantine-color-text)',
    color = 'var(--mantine-color-gray-6)',
    fw = 300,
    ...props
}: ButtonProps) => {
    return (
        <MantineButton variant={variant} color={color} c={c} fw={fw} size={size} {...props}>
            {children}
        </MantineButton>
    );
};
